export default "__VITE_ASSET__df6f1d0d__"